var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5304 5.53044L20.0608 5.00011L19.0001 3.93945L18.4698 4.46978L12.0001 10.9395L5.53044 4.46978L5.00011 3.93945L3.93945 5.00011L4.46978 5.53044L10.9395 12.0001L4.46978 18.4698L3.93945 19.0001L5.00011 20.0608L5.53044 19.5304L12.0001 13.0608L18.4698 19.5304L19.0001 20.0608L20.0608 19.0001L19.5304 18.4698L13.0608 12.0001L19.5304 5.53044Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b3acebae6c3bd52f3bdee4d14cce3df6.svg";
export { ForwardRef as ReactComponent };